import InputMaskNumber from './input-mask-number'

export default InputMaskNumber